// Header.js
import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import validemyLogo from '../assets/validemy-logo.png';
import validemyLogoWhite from '../assets/validemy-logo-white.png';

const Header = () => {
  const location = useLocation();
  const isHome = location.pathname === '/';
  const [isOpen, setIsOpen] = useState(false);

  return (
    <header
      className={
        isHome
          ? 'absolute top-0 left-0 w-full z-50'
          : 'w-full bg-white relative z-50'
      }
    >
      <div
        className={
          (isHome
            ? 'mx-3 md:mx-10 lg:mx-16 mt-4 md:mt-6 px-6 md:px-12 lg:px-16'
            : 'px-4 md:px-24') +
          (isHome
            ? ' py-4 flex items-center justify-between'
            : ' w-full py-4 flex items-center justify-between')
        }
      >
        <div className="flex items-center">
          <Link to="/" aria-label="Validemy">
            <img
              src={isHome ? validemyLogoWhite : validemyLogo}
              alt="Validemy"
              className="h-16"
            />
          </Link>
        </div>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center">
          <div
            className={
              (isHome
                ? 'bg-white/10 border border-white/20 backdrop-blur-md'
                : '') +
              ' flex items-center rounded-full p-1'
            }
          >
            <Link
              to="/"
              className={
                (isHome
                  ? 'px-4 py-2 rounded-full text-white text-sm font-inter bg-white/10'
                  : 'px-4 py-2 rounded-full text-acBlack text-sm font-inter hover:bg-gray-50')
              }
            >
              Home
            </Link>
            <Link
              to="/#courses"
              className={
                (isHome
                  ? 'px-4 py-2 rounded-full text-white/80 text-sm font-inter hover:text-white'
                  : 'px-4 py-2 rounded-full text-acBlack text-sm font-inter hover:bg-gray-50')
              }
            >
              Courses
            </Link>
            {/* <Link
              to="/#submit-course"
              className={
                (isHome
                  ? 'px-4 py-2 rounded-full text-white/80 text-sm font-inter hover:text-white'
                  : 'px-4 py-2 rounded-full text-acBlack text-sm font-inter hover:bg-gray-50')
              }
            >
              For Creators
            </Link> */}
            <Link
              to="/contact"
              className={
                (isHome
                  ? 'px-4 py-2 rounded-full text-white/80 text-sm font-inter hover:text-white'
                  : 'px-4 py-2 rounded-full text-acBlack text-sm font-inter hover:bg-gray-50')
              }
            >
              Contact
            </Link>
          </div>
        </nav>

        <div className="hidden md:flex items-center gap-3">
          {/* <Link
            to="/#submit-course"
            className={
              'px-4 py-2 rounded-full border text-sm font-inter transition ' +
              (isHome
                ? 'border-white/30 text-white bg-white/10 hover:bg-white/15'
                : 'border-gray-300 text-acBlack hover:bg-gray-50')
            }
          >
            Submit a Course
          </Link> */}
          <Link
            to="/#courses"
            className={
              'px-5 py-2.5 rounded-full text-sm font-inter font-semibold transition ' +
              (isHome
                ? 'border border-white/30 text-white bg-white/10 hover:bg-white/15'
                : 'bg-acBlack text-white hover:opacity-90')
            }
          >
            Browse Courses
          </Link>
        </div>

        {/* Mobile Menu Button */}
        <button
          className={"md:hidden " + (isHome ? 'text-white' : 'text-acBlack')}
          onClick={() => setIsOpen(!isOpen)}
          aria-label={isOpen ? 'Close menu' : 'Open menu'}
        >
          {isOpen ? <X size={30} /> : <Menu size={30} />}
        </button>

        {/* Mobile Nav */}
        {isOpen && (
          <div className="absolute top-16 left-0 w-full bg-white shadow-md flex flex-col items-center space-y-4 py-6 md:hidden z-40">
            <Link to="/" className="hover:opacity-80 transition" onClick={() => setIsOpen(false)}>
              Home
            </Link>
            <Link
              to="/#courses"
              className="hover:opacity-80 transition"
              onClick={() => setIsOpen(false)}
            >
              Courses
            </Link>
            <Link
              to="/#submit-course"
              className="hover:opacity-80 transition"
              onClick={() => setIsOpen(false)}
            >
              For Creators
            </Link>
            <Link to="/contact" className="hover:opacity-80 transition" onClick={() => setIsOpen(false)}>
              Contact
            </Link>

            <div className="flex flex-col gap-3 w-full px-6 pt-2">
              <Link
                to="/#courses"
                className="w-full text-center px-5 py-3 rounded-full bg-acBlack text-white text-sm font-inter font-semibold"
                onClick={() => setIsOpen(false)}
              >
                Browse Courses
              </Link>
              <Link
                to="/#submit-course"
                className="w-full text-center px-5 py-3 rounded-full border border-gray-300 text-acBlack text-sm font-inter"
                onClick={() => setIsOpen(false)}
              >
                Submit a Course
              </Link>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
